import type { DateInput } from './dates';
import { toDateSafe } from './dates';
import type { Event } from './types';

export function eventTypeLabel(type: Event['type'] | string | undefined): string {
  if (type === 'webinar') return 'Webinar';
  if (type === 'in_person') return 'In person';
  return 'Meeting';
}

export function formatEventRange(startAt: DateInput, endAt: DateInput) {
  const s = toDateSafe(startAt);
  const e = toDateSafe(endAt);
  if (!s && !e) return 'Date to be confirmed';
  if (s && !e) return s.toLocaleString(undefined, { year: 'numeric', month: 'short', day: '2-digit' });
  if (!s || !e) return 'Date to be confirmed';

  const sameDay =
    s.getFullYear() === e.getFullYear() &&
    s.getMonth() === e.getMonth() &&
    s.getDate() === e.getDate();

  const dateFmt: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: '2-digit' };
  const timeFmt: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' };

  const sDate = s.toLocaleDateString(undefined, dateFmt);
  const sTime = s.toLocaleTimeString(undefined, timeFmt);
  const eDate = e.toLocaleDateString(undefined, dateFmt);
  const eTime = e.toLocaleTimeString(undefined, timeFmt);

  return sameDay ? `${sDate}, ${sTime} - ${eTime}` : `${sDate}, ${sTime} - ${eDate}, ${eTime}`;
}

export function eventPrimaryUrl(event: Pick<Event, 'registrationUrl' | 'externalUrl' | 'join'>): string {
  return String(event.registrationUrl || event.externalUrl || event.join?.url || '').trim();
}
